var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4286 0.443359C21.0979 0.443359 21.7399 0.70926 22.2132 1.18257C22.6865 1.65587 22.9524 2.29781 22.9524 2.96717V20.6338C22.9524 21.3032 22.6865 21.9451 22.2132 22.4184C21.7399 22.8917 21.0979 23.1576 20.4286 23.1576H2.7619C2.09255 23.1576 1.45061 22.8917 0.977301 22.4184C0.503995 21.9451 0.238094 21.3032 0.238094 20.6338V2.96717C0.238094 2.29781 0.503995 1.65587 0.977301 1.18257C1.45061 0.70926 2.09255 0.443359 2.7619 0.443359H20.4286ZM19.7976 20.0029V13.3148C19.7976 12.2237 19.3642 11.1774 18.5927 10.4059C17.8212 9.6344 16.7749 9.20098 15.6838 9.20098C14.6112 9.20098 13.3619 9.85717 12.7562 10.8415V9.44074H9.23548V20.0029H12.7562V13.7817C12.7562 12.81 13.5386 12.015 14.5102 12.015C14.9788 12.015 15.4281 12.2012 15.7595 12.5325C16.0908 12.8638 16.2769 13.3131 16.2769 13.7817V20.0029H19.7976ZM5.13428 7.45955C5.69654 7.45955 6.23577 7.23619 6.63335 6.83862C7.03093 6.44104 7.25428 5.90181 7.25428 5.33955C7.25428 4.16598 6.30786 3.20693 5.13428 3.20693C4.56868 3.20693 4.02624 3.43162 3.6263 3.83156C3.22635 4.2315 3.00167 4.77394 3.00167 5.33955C3.00167 6.51312 3.96071 7.45955 5.13428 7.45955ZM6.88833 20.0029V9.44074H3.39286V20.0029H6.88833Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3919ac4f2686f6e621fc0b6bff4a3757.svg";
export { ForwardRef as ReactComponent };